/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment } from 'react';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import { Breadcrumbs } from '../../../AbstractElements';
import '../../../App.css'
import Grow from '@mui/material/Grow';
import Grid from '@mui/material/Grid';
import NewReportsModal from './NewReportsModal';
import CheckReportsModal from './CheckReportsModal';

const Reports = () => {
  return (
    <Fragment>
    <br />
      <Breadcrumbs phish mainTitle="Segnalazioni" parent="DomusVestra" title="Segnalazioni" />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Grow in={true}><div>
            <Card>
              <CardBody>
                <h2><b>Segnalazioni</b></h2><br />
                <p>
                  Ti diamo il benvenuto nel sistema di segnalazioni.<br />
                  Con questa piattaforma potrai segnalare ogni comportamento e irregolarità da cui possa derivare una violazione (o un tentativo di violazione) di specifiche disposizioni di legge o di politiche aziendali.<br />
                  Le segnalazioni possono riguardare anche ogni comportamento e irregolarità da cui possa derivare un danno per l'azienda, per clienti, soci, investitori e dipendenti, compresi episodi di mobbing e violazioni della normativa privacy.<br />
                  La piattaforma è sviluppata secondo i più elevati standard di privacy e sicurezza dei dati.<br />
                  Anche se la tua segnalazione non contiene dati personali, ti invitiamo comunque a leggere l'informativa privacy per comprendere meglio il loro eventuale trattamento, qualora ce ne fosse bisogno.<br />
                  Per inviare una segnalazione di violazione o illecito clicca sul pulsante Apri nuova segnalazione.<br />
                  Ti invitiamo a leggere l'istruzione che trovi dopo aver aperto la segnalazione.<br />
                  Nel caso di "Whistleblowing" dopo avere inviato la segnalazione potrai copiare il codice per esaminare lo stato in seguito oppure, in alternativa, potrai copiare il link univoco per esaminare la specifica segnalazione che hai inviato.<br />
                  Per verificare lo stato di avanzamento di una segnalazione "Whistleblowing" precedentemente inviata clicca sul pulsante Esamina segnalazione esistente.<br />
                </p><br />
                <Grid container spacing={2}>
                  <Grid item xs={3}></Grid>
                  <Grid item xs={3}>
                    <NewReportsModal />
                  </Grid>
                  <Grid item xs={3}>
                    <CheckReportsModal />
                  </Grid>
                  <Grid item xs={3}></Grid>
                </Grid>
              </CardBody>
            </Card>
            </div></Grow>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default Reports;